"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } } function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkMQ5AGG7Cjs = require('./chunk-MQ5AGG7C.js');var _chunkOL2KRAIPjs = require('./chunk-OL2KRAIP.js');var _chunkNL46QAWKjs = require('./chunk-NL46QAWK.js');var _react = require('react'); var l = _interopRequireWildcard(_react);var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _jsxruntime = require('react/jsx-runtime');var g=20,p=_styled2.default.div`
  display: inline-flex;
  align-items: center;
  flex-direction: row;
  width: fit-content;
  height: ${e=>e.theme.measurements.spacing(20)};
  padding-right: ${e=>e.$isIconPresent?e.theme.measurements.spacing(8):e.theme.measurements.spacing(10)};
  padding-left: ${e=>e.$isIconPresent?e.theme.measurements.spacing(4):e.theme.measurements.spacing(10)};
  gap: ${e=>e.theme.measurements.spacing(4)};
  border: ${e=>`${e.theme.measurements.spacing(.5)} solid ${e.$isSelected?e.theme.palette.PRIMARY:e.theme.palette.DIVIDER}`};
  border-radius: ${e=>e.theme.measurements.spacing(16)};
  background-color: ${e=>e.theme.palette.BASE_ONE};
  transition: border-color 200ms ease-in-out, background-color 200ms ease-in-out;

  &.aquilla-pill-btn {
    &:hover {
      background-color: ${e=>e.theme.palette.BASE_ZERO};
    }
    &:not(:disabled) {
      cursor: pointer;
      &:active {
        background-color: ${e=>e.theme.palette.DIVIDER};
      }
    }
  }
  @media screen and (max-width: ${e=>e.theme.breakpoint.mobile}) {
    height: ${e=>e.theme.measurements.spacing(18)};
    padding-right: ${e=>e.$isIconPresent?e.theme.measurements.spacing(6):e.theme.measurements.spacing(8)};
    padding-left: ${e=>e.$isIconPresent?e.theme.measurements.spacing(3):e.theme.measurements.spacing(8)};
  }
`,$=_styled2.default.call(void 0, _chunkMQ5AGG7Cjs.b)`
  font-weight: ${e=>e.$isSelected?600:400};
`,c= exports.a =l.forwardRef((e,d)=>{let{title:t,isSelected:a,icon:i,onClick:n}=e,h=_chunkOL2KRAIPjs.b.call(void 0, );return _jsxruntime.jsxs.call(void 0, p,{ref:d,"aria-label":t,onClick:n,as:n?"button":"div",className:`${n?"aquilla-pill-btn":""}`,$isSelected:a,$isIconPresent:Boolean(i),children:[i,_jsxruntime.jsx.call(void 0, $,{variant:"h6",as:"span",color:h.PRIMARY,$isSelected:a,title:t,children:_chunkNL46QAWKjs.a.call(void 0, t,g)})]})});c.displayName="Pill";var S=c;exports.a = c; exports.b = S;
